import React, { useEffect, useState } from 'react'
import { Typography, Card, Input, Button, List, message, Popconfirm, Tag, Empty } from 'antd'
import { SendOutlined, DeleteOutlined, MessageOutlined } from '@ant-design/icons'
import { messagesAPI } from '../services/api'
import dayjs from 'dayjs'

const { Title, Text } = Typography

function Mensajes() {
  const [messages, setMessages] = useState([])
  const [text, setText] = useState('')
  const [sending, setSending] = useState(false)

  useEffect(() => { load() }, [])

  const load = async () => {
    try {
      const res = await messagesAPI.getAll()
      setMessages(res.data)
    } catch (e) { message.error('Error cargando mensajes') }
  }

  const handleSend = async () => {
    if (!text.trim()) { message.warning('Escribí un mensaje'); return }
    setSending(true)
    try {
      await messagesAPI.create(text)
      message.success('Mensaje publicado para todas las alumnas')
      setText('')
      load()
    } catch (e) { message.error('Error enviando mensaje') }
    setSending(false)
  }

  const handleDelete = async (id) => {
    try {
      await messagesAPI.remove(id)
      message.success('Mensaje eliminado')
      load()
    } catch (e) { message.error('Error') }
  }

  return (
    <div style={{ maxWidth: 720 }}>
      <Title level={4} style={{ margin: 0, marginBottom: 12 }}>Mensajes</Title>

      <Card size="small" style={{ borderRadius: 12, marginBottom: 12 }}>
        <Text style={{ display: 'block', marginBottom: 10, color: '#999' }}>
          <MessageOutlined /> Este mensaje aparece en el portal de las alumnas como "MENSAJE DE LA PROFE". El último enviado reemplaza al anterior.
        </Text>
        <Input.TextArea
          rows={3}
          placeholder="Escribí el mensaje para tus alumnas..."
          value={text}
          onChange={(e) => setText(e.target.value)}
          maxLength={500}
        />
        <Button
          type="primary"
          icon={<SendOutlined />}
          loading={sending}
          onClick={handleSend}
          style={{ marginTop: 10 }}
          disabled={!text.trim()}
        >
          Publicar mensaje
        </Button>
      </Card>

      <Card size="small" style={{ borderRadius: 12 }} title="Historial">
        {messages.length === 0 ? (
          <Empty description="Todavía no publicaste mensajes" image={Empty.PRESENTED_IMAGE_SIMPLE} />
        ) : (
          <List
            dataSource={messages}
            renderItem={(m) => (
              <List.Item
                style={{ padding: '10px 0' }}
                actions={[
                  <Popconfirm title="¿Eliminar mensaje?" onConfirm={() => handleDelete(m.id)}>
                    <Button size="small" type="text" danger icon={<DeleteOutlined />} />
                  </Popconfirm>
                ]}
              >
                <List.Item.Meta
                  title={
                    <span>
                      {m.text}
                      {m.active && <Tag color="green" style={{ marginLeft: 8 }}>Activo</Tag>}
                    </span>
                  }
                  description={dayjs(m.createdAt).format('DD/MM/YYYY HH:mm')}
                />
              </List.Item>
            )}
          />
        )}
      </Card>
    </div>
  )
}

export default Mensajes
